import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SaasApp from './saas/SaasApp';
import NotFound from './components/NotFound';
import './App.css';
import './components/LoadingSkeleton.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* SAAS Routes - all handled by SaasApp */}
        <Route path="/dashboard" element={<SaasApp />} />
        <Route path="/auth" element={<SaasApp />} />
        <Route path="/auth/*" element={<SaasApp />} />
        <Route path="/dashboard/*" element={<SaasApp />} />

        {/* Main landing page */}
        <Route path="/" element={<SaasApp />} />

        {/* 404 Not Found for unmatched routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
